define('Components/PageHeaderWidget/js/models/PageHeaderV3Model',['jquery',
        'app',
        'Components/PageHeaderWidget/js/models/PageHeaderV2Model'
    ],
    function ($, app, PageHeaderV2Model) {
        return PageHeaderV2Model.extend({
            name: 'PageHeaderV3Model',
            isDesktop: function(){
                return app.isDesktop();
            }
        })
    });
